module.exports = __webpack_public_path__ + "img/gradient-5.cf0cd53d.png";